export default __webpack_public_path__ + "static/media/img-cwa-4-new.6d7b70d1.png";